import dayjs from 'dayjs';
import { CalendarType } from '../../../types/consultation';

const en = document.documentElement.lang === 'en';

export function getAppointmentName(appointmentType: CalendarType): string {
  switch (appointmentType) {
    case CalendarType.Idd:
    case CalendarType.ExpatIdd:
    case CalendarType.IddTopUp:
    case CalendarType.IddDental:
      return en ? 'IDD appointment' : 'IDD Beratungsdokumentation';
    case CalendarType.Underwriting:
      return en ? 'Underwriting appointment' : 'Termin zur Gesundheitsprüfung';
    case CalendarType.Signup:
    case CalendarType.ExpatSignup:
      return en ? 'Enrollment call' : 'Termin zur Antragsaufnahme';
    case CalendarType.FollowUp:
    case CalendarType.ExpatFollowUp:
      return en ? 'Follow up consultation' : 'Folgeberatungstermin';
    case CalendarType.Upselling:
    case CalendarType.ExpatUpselling:
      return en ? 'Consultation for tariff change' : 'Termin zur Umstellung';
    case CalendarType.Bap:
    case CalendarType.ExpatBap:
      return en ? 'BAP appointment' : 'Termin für BAP';
    default:
      return en ? 'Phone consultation appointment' : 'Beratungstermin';
  }
}

export function prepareDateAndTime(start: string): string {
  const date = dayjs(start);
  if (en) {
    return date.format('dddd, MM/DD/YYYY [at] h:mm A');
  } else {
    return date.locale('de').format('dddd, DD.MM.YYYY [um] HH:mm [Uhr]');
  }
}
